import script from "./json-editor.vue?vue&type=script&setup=true&lang=js"
export * from "./json-editor.vue?vue&type=script&setup=true&lang=js"

import "./json-editor.vue?vue&type=style&index=0&id=1ceb9667&lang=scss&scoped=true"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ceb9667"]])

export default __exports__